import { composeMiddleware } from '../module';

import { QUEUE_EFFECT } from './constants';
import { effectActions } from './effectState';

export const queueEffectMiddleware = composeMiddleware(() => next => action => {
  if (action.type === QUEUE_EFFECT) {
    next(effectActions.queueEffect.create((action as any).payload));
    return;
  }

  return next(action);
});
